function IconGooglePlay(props: JSX.IntrinsicElements['svg']) {
  return (
    <svg
      width='160'
      height='46'
      viewBox='0 0 160 46'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M153.123 46H5.88933C2.65167 46 0 43.4111 0 40.25V5.75C0 2.58894 2.65167 2.43107e-06 5.88933 2.43107e-06H153.123C156.36 2.43107e-06 159.012 2.58894 159.012 5.75V40.25C159.012 43.4111 156.36 46 153.123 46Z'
        fill='#000'
      />
      <path
        d='M153.123 0.921437C155.849 0.921437 158.068 3.08775 158.068 5.75V40.25C158.068 42.9123 155.849 45.0786 153.123 45.0786H5.88933C3.16257 45.0786 0.943765 42.9123 0.943765 40.25V5.75C0.943765 3.08775 3.16257 0.921437 5.88933 0.921437H153.123ZM153.123 2.43107e-06H5.88933C2.65167 2.43107e-06 0 2.58894 0 5.75V40.25C0 43.4111 2.65167 46 5.88933 46H153.123C156.36 46 159.012 43.4111 159.012 40.25V5.75C159.012 2.58894 156.36 2.43107e-06 153.123 2.43107e-06Z'
        fill='#000'
      />
      <path
        d='M55.8514 11.7801C55.8514 12.7403 55.5569 13.5094 54.9768 14.083C54.3099 14.7629 53.4412 15.105 52.3767 15.105C51.3593 15.105 50.4906 14.7572 49.778 14.0715C49.0639 13.3757 48.7076 12.5218 48.7076 11.4998C48.7076 10.4777 49.0639 9.62384 49.778 8.93384C50.4906 8.24241 51.3593 7.89453 52.3767 7.89453C52.8832 7.89453 53.3661 7.99659 53.8269 8.18634C54.2863 8.37753 54.6603 8.63628 54.9312 8.95541L54.3158 9.56203C53.8431 9.01722 53.1997 8.74841 52.3767 8.74841C51.6346 8.74841 50.9912 9.00141 50.445 9.51172C49.9046 10.0235 49.6337 10.6862 49.6337 11.4998C49.6337 12.3134 49.9046 12.9818 50.445 13.4936C50.9912 13.9982 51.6346 14.2569 52.3767 14.2569C53.1644 14.2569 53.8269 13.9982 54.3496 13.4878C54.6941 13.15 54.89 12.6843 54.9415 12.0892H52.3767V11.2583H55.7984C55.8396 11.438 55.8514 11.6119 55.8514 11.7801Z'
        fill='white'
        stroke='white'
        strokeWidth='0.16'
        strokeMiterlimit='10'
      />
      <path
        d='M61.28 8.89954H58.0659V11.0845H60.9635V11.9154H58.0659V14.1004H61.28V14.9471H57.156V8.05286H61.28V8.89954Z'
        fill='white'
        stroke='white'
        strokeWidth='0.16'
        strokeMiterlimit='10'
      />
      <path
        d='M65.111 14.9471H64.2011V8.89954H62.2296V8.05286H67.0839V8.89954H65.111V14.9471Z'
        fill='white'
        stroke='white'
        strokeWidth='0.16'
        strokeMiterlimit='10'
      />
      <path
        d='M70.5969 14.9471V8.05286H71.5054V14.9471H70.5969Z'
        fill='white'
        stroke='white'
        strokeWidth='0.16'
        strokeMiterlimit='10'
      />
      <path
        d='M75.5321 14.9471H74.6296V8.89954H72.6508V8.05286H77.5109V8.89954H75.5321V14.9471Z'
        fill='white'
        stroke='white'
        strokeWidth='0.16'
        strokeMiterlimit='10'
      />
      <path
        d='M86.7011 14.06C86.0047 14.7572 85.1419 15.105 84.1127 15.105C83.0777 15.105 82.2149 14.7572 81.5185 14.06C80.8235 13.3642 80.4775 12.5103 80.4775 11.4998C80.4775 10.4892 80.8235 9.63534 81.5185 8.93959C82.2149 8.24241 83.0777 7.89453 84.1127 7.89453C85.136 7.89453 85.9988 8.24241 86.6952 8.94534C87.396 9.64684 87.742 10.495 87.742 11.4998C87.742 12.5103 87.396 13.3642 86.7011 14.06ZM82.1913 13.4821C82.7155 13.9982 83.353 14.2569 84.1127 14.2569C84.8666 14.2569 85.51 13.9982 86.0282 13.4821C86.5509 12.966 86.8159 12.3033 86.8159 11.4998C86.8159 10.6962 86.5509 10.0335 86.0282 9.51747C85.51 9.00141 84.8666 8.74266 84.1127 8.74266C83.353 8.74266 82.7155 9.00141 82.1913 9.51747C81.6687 10.0335 81.4036 10.6962 81.4036 11.4998C81.4036 12.3033 81.6687 12.966 82.1913 13.4821Z'
        fill='white'
        stroke='white'
        strokeWidth='0.16'
        strokeMiterlimit='10'
      />
      <path
        d='M89.0186 14.9471V8.05286H90.1228L93.5563 13.4147H93.596L93.5563 12.0894V8.05286H94.4647V14.9471H93.5165L89.9211 9.32073H89.8813L89.9211 10.6519V14.9471H89.0186Z'
        fill='white'
        stroke='white'
        strokeWidth='0.16'
        strokeMiterlimit='10'
      />
      <path
        d='M80.2539 25.0157C77.4874 25.0157 75.2273 27.0713 75.2273 29.9075C75.2273 32.7207 77.4874 34.7979 80.2539 34.7979C83.0263 34.7979 85.2863 32.7207 85.2863 29.9075C85.2863 27.0713 83.0263 25.0157 80.2539 25.0157ZM80.2539 32.8716C78.7359 32.8716 77.4299 31.6483 77.4299 29.9075C77.4299 28.1437 78.7359 26.942 80.2539 26.942C81.7718 26.942 83.0837 28.1437 83.0837 29.9075C83.0837 31.6483 81.7718 32.8716 80.2539 32.8716ZM69.2865 25.0157C66.5141 25.0157 64.2599 27.0713 64.2599 29.9075C64.2599 32.7207 66.5141 34.7979 69.2865 34.7979C72.0574 34.7979 74.313 32.7207 74.313 29.9075C74.313 27.0713 72.0574 25.0157 69.2865 25.0157ZM69.2865 32.8716C67.767 32.8716 66.4566 31.6483 66.4566 29.9075C66.4566 28.1437 67.767 26.942 69.2865 26.942C70.8044 26.942 72.1104 28.1437 72.1104 29.9075C72.1104 31.6483 70.8044 32.8716 69.2865 32.8716ZM56.2357 26.515V28.5936H61.3197C61.171 29.7551 60.7734 30.609 60.1639 31.2041C59.4218 31.9229 58.2661 32.7207 56.2357 32.7207C53.107 32.7207 50.657 30.2554 50.657 27.2007C50.657 24.146 53.107 21.6807 56.2357 21.6807C57.9274 21.6807 59.1583 22.3261 60.0667 23.1628L61.567 21.698C60.2964 20.5135 58.6062 19.6035 56.2357 19.6035C51.9453 19.6035 48.3396 23.0118 48.3396 27.2007C48.3396 31.3896 51.9453 34.7979 56.2357 34.7979C58.5546 34.7979 60.2964 34.0561 61.6657 32.6646C63.0688 31.2947 63.5061 29.3685 63.5061 27.8131C63.5061 27.3301 63.4649 26.8859 63.3912 26.515H56.2357ZM109.602 28.1265C109.188 27.0325 107.912 25.0157 105.311 25.0157C102.735 25.0157 100.59 26.998 100.59 29.9075C100.59 32.6474 102.713 34.7979 105.559 34.7979C107.86 34.7979 109.188 33.428 109.734 32.6301L108.026 31.519C107.457 32.3326 106.681 32.8716 105.559 32.8716C104.444 32.8716 103.645 32.3728 103.132 31.3896L109.833 28.6828L109.602 28.1265ZM102.77 29.7551C102.713 27.8691 104.271 26.9031 105.387 26.9031C106.261 26.9031 107.003 27.3301 107.251 27.941L102.77 29.7551ZM97.3241 34.5003H99.5267V20.1253H97.3241V34.5003ZM93.7169 26.1053H93.6433C93.1486 25.5332 92.2048 25.0157 91.0093 25.0157C88.5004 25.0157 86.2065 27.1662 86.2065 29.9233C86.2065 32.6646 88.5004 34.7979 91.0093 34.7979C92.2048 34.7979 93.1486 34.2761 93.6433 33.6867H93.7169V34.3882C93.7169 36.2584 92.6936 37.2632 91.0431 37.2632C89.6974 37.2632 88.8626 36.3145 88.5181 35.5166L86.6026 36.2972C87.1547 37.5938 88.6167 39.1895 91.0431 39.1895C93.6256 39.1895 95.8046 37.706 95.8046 34.0964V25.3133H93.7169V26.1053ZM91.1977 32.8716C89.6797 32.8716 88.4091 31.6311 88.4091 29.9233C88.4091 28.1998 89.6797 26.942 91.1977 26.942C92.6936 26.942 93.8729 28.1998 93.8729 29.9233C93.8729 31.6311 92.6936 32.8716 91.1977 32.8716ZM119.914 20.1253H114.646V34.5003H116.843V29.0536H119.914C122.354 29.0536 124.746 27.3301 124.746 24.5888C124.746 21.8489 122.348 20.1253 119.914 20.1253ZM119.971 27.0541H116.843V22.1249H119.971C121.612 22.1249 122.548 23.4546 122.548 24.5888C122.548 25.7014 121.612 27.0541 119.971 27.0541ZM133.551 24.9884C131.964 24.9884 130.313 25.6726 129.634 27.1892L131.584 27.987C132.003 27.1892 132.775 26.9305 133.591 26.9305C134.73 26.9305 135.886 27.5989 135.904 28.7791V28.93C135.506 28.7058 134.655 28.3737 133.608 28.3737C131.509 28.3737 129.369 29.5021 129.369 31.6081C129.369 33.5343 131.089 34.7749 133.022 34.7749C134.5 34.7749 135.316 34.1237 135.829 33.3661H135.904V34.4773H138.025V28.9631C138.025 26.4144 136.076 24.9884 133.551 24.9884ZM133.286 32.8659C132.567 32.8659 131.566 32.518 131.566 31.6483C131.566 30.5357 132.815 30.1088 133.895 30.1088C134.863 30.1088 135.316 30.3172 135.904 30.5918C135.731 31.9229 134.558 32.8659 133.286 32.8659ZM145.755 25.3032L143.23 31.5348H143.155L140.544 25.3032H138.175L142.098 34.0116L139.86 38.8574H142.155L148.199 25.3032H145.755ZM125.954 34.5003H128.156V20.1253H125.954V34.5003Z'
        fill='white'
      />
      <path
        d='M12.291 8.67017C11.945 9.0238 11.7448 9.57436 11.7448 10.2874V35.7196C11.7448 36.4326 11.945 36.9832 12.291 37.3368L12.3764 37.4144L26.9731 23.1688V22.8324L12.3764 8.5868L12.291 8.67017Z'
        fill='url(#paint0_linear_2_334)'
      />
      <path
        d='M31.8333 27.9183L26.9731 23.1674V22.831L31.8392 18.0801L31.9482 18.1419L37.7109 21.3432C39.3555 22.2517 39.3555 23.7467 37.7109 24.661L31.9482 27.8565L31.8333 27.9183Z'
        fill='url(#paint1_linear_2_334)'
      />
      <path
        d='M31.9482 27.8567L26.9732 22.9994L12.2911 37.3356C12.8374 37.8962 13.7281 37.9638 14.7411 37.4032L31.9482 27.8567Z'
        fill='url(#paint2_linear_2_334)'
      />
      <path
        d='M31.9482 18.1428L14.7411 8.59638C13.7281 8.0415 12.8374 8.10906 12.2911 8.66969L26.9732 23.0001L31.9482 18.1428Z'
        fill='url(#paint3_linear_2_334)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_2_334'
          x1='25.6771'
          y1='35.9845'
          x2='6.38284'
          y2='16.2227'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#00A0FF' />
          <stop offset='0.0066' stopColor='#00A1FF' />
          <stop offset='0.2601' stopColor='#00BEFF' />
          <stop offset='0.5122' stopColor='#00D2FF' />
          <stop offset='0.7604' stopColor='#00DFFF' />
          <stop offset='1' stopColor='#00E3FF' />
        </linearGradient>
        <linearGradient
          id='paint1_linear_2_334'
          x1='39.8524'
          y1='22.9976'
          x2='11.3517'
          y2='22.9976'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFE000' />
          <stop offset='0.4087' stopColor='#FFBD00' />
          <stop offset='0.7754' stopColor='#FFA500' />
          <stop offset='1' stopColor='#FF9C00' />
        </linearGradient>
        <linearGradient
          id='paint2_linear_2_334'
          x1='29.243'
          y1='20.3589'
          x2='3.07844'
          y2='-6.43963'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF3A44' />
          <stop offset='1' stopColor='#C31162' />
        </linearGradient>
        <linearGradient
          id='paint3_linear_2_334'
          x1='8.59535'
          y1='45.7975'
          x2='20.279'
          y2='33.8309'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#32A071' />
          <stop offset='0.0685' stopColor='#2DA771' />
          <stop offset='0.4762' stopColor='#15CF74' />
          <stop offset='0.8009' stopColor='#06E775' />
          <stop offset='1' stopColor='#00F076' />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default IconGooglePlay;
